import {
  ComposedChart,
  Line,
  Area,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

// #endregion
const VerticalComposedChart = ({ statsWidget }) => {
  return (
    <div className="card rounded-4">
      <div className="card-body">
        <h6>أفضل المتاجر حسب الإيرادات</h6>
        <ComposedChart
          layout="vertical"
          style={{
            width: "100%",
            height: "40vh",
            aspectRatio: 1 ,
            direction: "rtl",
          }}
          responsive
          data={statsWidget?.charts?.top_stores_by_revenue}
          margin={{
            top: 20,
            right: 0,
            bottom: 0,
            left: 0,
          }}
        >
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" scale="band" width={150} />
          <Tooltip />
          <Legend />

          <Bar dataKey="revenue" barSize={100} name={"المبيعات"} fill="#FFCC03" />
        </ComposedChart>
      </div>
    </div>
  );
};

export default VerticalComposedChart;
